var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-info",class:_vm.className},[_c('span',{staticClass:"dot dot-l"}),_vm._v("五行属"+_vm._s(_vm.titleText)),_c('span',{staticClass:"dot dot-r"})])}
var staticRenderFns = []

export { render, staticRenderFns }